import React from 'react'

import {
  List,
  type ListProps,
  Table,
  type TableProps,
  useMediaQueryContext,
} from '@fourthwall/components'

export type AnalyticsReportsDataProps = {
  list: ListProps
  table: TableProps
}

export const AnalyticsReportsData = ({ list, table }: AnalyticsReportsDataProps) => {
  const media = useMediaQueryContext()

  if (!media.tablet) {
    return <List {...list} />
  }

  return <Table {...table} />
}
